import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/views/Layout/Layout.vue'),
    children: [{
      path: '/Home',
      name: 'Home',
      meta: {
        title: '首页',
        closable: false,
      },
      component: () => import('@/views/Home.vue')
    }]
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (!to.name) {
    next({
      name: 'Home'
    });
    return;
  }
  if (!sessionStorage.getItem('token') && to.name !== 'Login') {
    next({
      name: 'Login'
    })
  } else {
    next()
  }

})
export default router
